import React from 'react'
import styles from './Chapter.module.css'
import Quotes from '../../../components/Quotes/Quotes'
const C2_TheHumanUniverse = () => {
    return (
        <div>
            <div className={styles.heading}>
                <h3>Chapter 2</h3>
                <h2>The Human Universe</h2>
                <hr />
            </div>
            <div className={styles.content}>
                <Quotes text="A plate, a cup, and a bowl are all made from the same clay. Like this, all creation is made from the same eternal Brahman." author="Upanishadic wisdom"/>
            </div>
        </div>
    )
}

export default C2_TheHumanUniverse